import { JoinDescriptionId } from './fd-join-description';

export type DomainsDescriptionId = DomainId & { opIdx: number };

export interface DomainsDescription {
  id: DomainsDescriptionId;
  description: string;
  domains: DomainId[];
}

export interface DomainId {
  joinId: JoinDescriptionId;
  domainIdx: number;
}

export namespace DomainsDescriptionId {
  export type String = string;

  export function toString(id: DomainsDescriptionId) {
    return `${id.joinId}_${id.domainIdx}_${id.opIdx}`;
  }

  export function listToMap(
    list: DomainsDescriptionId[]
  ): Map<DomainsDescriptionId.String, DomainsDescriptionId> {
    return new Map(list.map(el => [DomainsDescriptionId.toString(el), el]));
  }
}
